import React from "react";
import PdfViewer from "../../PdfViewer";

const PythonTema3 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema3_Programacion_Basica.pdf`;
  /*const pdfUrl = "/pdf/Tema3_Programacion_Basica.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Tema 3: Programación Básica</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PythonTema3;
